import { ProductFilterFormData } from "entities/products/types/ProductFilter"
import { map } from "nanostores"

const defaultState: ProductFilterFormData = {
  searchTerm: null
}

// Deliberately not persisted: a search term that survives a browser restart
// silently hides most of the portfolio, and the URL already carries the state.
export const portfolioFilterStore = map<ProductFilterFormData>(defaultState)

export function setFilterState(state: ProductFilterFormData) {
  portfolioFilterStore.set(state)
}

export function updateFilterState(updates: Partial<ProductFilterFormData>) {
  const currentState = portfolioFilterStore.get()
  portfolioFilterStore.set({ ...currentState, ...updates })
}

export function resetFilterState() {
  portfolioFilterStore.set(defaultState)
}
